define(["require", "exports", "./listMenu"], function (require, exports, listMenu_1) {
    "use strict";
    exports.__esModule = true;
    var UserMenu = [
        { name: 'Settings', href: '/customer/info' },
        { name: 'Addresses', href: '/customer/addresses' },
        { name: 'Orders', href: '/customer/orders' },
        { name: 'Favorites', href: '/customer/favorites' },
        { name: 'Reward points', href: '/customer/rewardpoints' },
        { name: 'Change password', href: '/customer/changepassword' },
        { name: 'Log out', href: '/logout' }
    ];
    $(function () {
        var anchor = $('.icon-head.user-menu');
        listMenu_1.ensureListMenu({
            anchor: anchor,
            className: 'user-menu-list',
            align: 'right'
        }, UserMenu);
    });
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/userMenu.js
// module id = 84
// module chunks = 0